import { Box } from "@material-ui/core";
import { generateAdText, SelectedProject } from "api";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { RoutesUrl } from "../../common/consts/Routes";
import { find, findAndUpdate, getData, store } from "../../services/service";
import CardComponent from "../shared/CardComponent";
import FormComponent, { FormData } from "../shared/test";
export type Project = {
    [key: string]: string;
}
function NewAvatar() {
    let { id }: any = useParams();
    const { push } = useHistory();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [formData, setFormData] = useState<FormData>({
        dynamicRows: [],
        adText: "", // Initialize with empty string
        project: "" // Initialize with empty string
    });
    const [projects, setProjects] = useState<SelectedProject[]>([]);
    const [selectedProject, setSelectedProject] = useState<SelectedProject | undefined>();
    useEffect(() => {
        getData("parametrics").then((parametrics) => {
            if (parametrics.length > 0) {
                setProjects(parametrics);
            }
        });
        if (id) {
            setIsLoading(true);
            find("gurus", id)
                .then((val) => {
                    if (!!!val?.dynamicRows) {
                        val.dynamicRows = [];
                    }
                    setFormData(val);
                })
                .finally(() => setIsLoading(false));
        } else {
            setFormData({
                dynamicRows: [] as any,
            });
        }
    }, [id]);
    useEffect(() => {
        const selected = projects?.find((project) => project?.project === formData?.project || "") || undefined;
        if (selected) {
            setSelectedProject(selected);
        }
    }, [formData.project])
    return (
        <Box>
            <CardComponent title={`New Market Guru`} isLoading={isLoading}>
                <FormComponent
                    staticFields={[
                        {
                            name: "project",
                            label: "Проект",
                            type: "autocomplete",
                            options: projects.map((project) => project.project),
                            required: true,
                            validation: (v) => {
                                if (!v) {
                                    return "Полето е задължително!";
                                }
                            },
                        },
                        { name: "adText", label: "Рекламен текст", type: "text", required: true, textFieldProps: { multiline: true } },
                    ]}

                    onSubmit={async (data) => {
                        // TO DO:
                        // Important!
                        console.log("Submitted Data:", data); // Log submitted data

                        try {
                            if (id) {
                                await findAndUpdate("gurus", id, data);
                                toast.success("Успешно редактиране");
                                push(RoutesUrl.gurus.list);
                                return;
                            }
                            await store("gurus", data);
                            toast.success("Успешно добавяне");
                            push(RoutesUrl.gurus.list);
                            return true;
                        } catch (e) {
                            toast.error("Нещо се обърка");
                            console.error(e);
                            return false;
                        }
                    }}
                    editMode={id ? true : false}
                    formData={formData}
                    setFormData={setFormData}
                    onGenerateAiData={async (data) => {
                        if (selectedProject) {
                            setIsLoading(true);
                            const adText = await generateAdText(selectedProject);
                            setFormData(prevData => ({
                                ...prevData,
                                adText: adText
                            }));
                            setIsLoading(false);
                        } else {
                            toast.error("Моля, изберете проект!");
                        }

                    }}
                />
            </CardComponent>
        </Box>
    )
}

export default NewAvatar;